import React, { useState, useCallback, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useFetch from '../../hooks/useFetch';
import { logout } from "../../redux/actions/authActions";
// import { GenerateDigiBCode } from '../../components/GenerateThink5whysCode';

const ExamUnionSuggestQuest = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [activeTab, setActiveTab] = useState("about");
  const isLoggedIn = authState?.isLoggedIn || false;
  const userId = authState.user._id;
  const userEmail = authState.user.email;
  const userName = authState?.user?.name || "User";
  const userThink5WhysCode = authState?.user?.think5whyscode || ""; 
  const [isCreated, setIsCreated] = useState(false);
  const [userQuestionList, setUserQuestionList] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const InputField = ({ label, className = "", ...props }) => (
  <div className="flex flex-col gap-1.5">
    {label && (
      <label className="text-sm font-medium text-gray-300">{label}</label>
    )}
    <input
      {...props}
      className={`w-full px-4 py-3 rounded-xl bg-white text-gray-800 
                 focus:outline-none focus:ring-2 focus:ring-blue-500 
                 disabled:bg-gray-100 disabled:text-gray-500 ${className}`}
    />
  </div>
);

const TextAreaField = ({ label, rows = 4, className = "", ...props }) => (
  <div className="flex flex-col gap-1.5">
    {label && (
      <label className="text-sm font-medium text-gray-300">{label}</label>
    )}
    <textarea
      {...props}
      rows={rows}
      className={`w-full px-4 py-3 rounded-xl bg-white text-gray-800 
                 focus:outline-none focus:ring-2 focus:ring-blue-500 
                 resize-y min-h-[100px] ${className}`}
    />
  </div>
);

  const [formData, setFormData] = useState({
    // 🔹 Core Question
    question: "",
    questionType: "MCQ",

    // 🔹 MCQ Structure
    mcqOptions: {
      A: "",
      B: "",
      C: "",
      D: ""
    },
    mcqCorrectAnswer: "A",

    // 🔹 Mapping (your existing UI fields reused)
    subject: "",
    chapter: "",
    tags: [],
    idealShortAnswer: "",

    // 🔹 Difficulty / Metadata
    difficulty: "Medium",
    concept: [],

    // 🔹 Scoring
    correctAnswerPoints: 4,
    wrongAnswerPoints: -1,

    // 🔹 System Flags
    isT5w: 0,
    hasExplanation: 0,
    isActive: 1,
    isDeleted: 0,
    isUserQuestion: true,
    isApproved: false,

    // 🔹 Image Handling
    isImageQuestion: 0,
    questionImage: "",
    hasOptionImages: 0,
    imageType: "",

    // 🔹 Ownership (auto-filled)
    createBy: userId,
    userCode: userThink5WhysCode,
    dateCreated: new Date(),

    // 🔹 Optional linkage
    setId: null,
    setCode: "",
    seriesId: null,
    questionDisplaySn: 0,
    questionId: `UQ-${Date.now()}`,

    examId: null,
    examTitle: "",
    section: ""
  });

  const fetchUserQuestions = useCallback(() => {
      const config = {
          url: "/userquests",
          method: "post",
          headers: { Authorization: authState.token }
      };

      fetchData(config, { showSuccessToast: false })
          .then(response => {
              if (response && Array.isArray(response.questionlist)) {
                  setUserQuestionList(response.questionlist);
              }
          })
          .catch(console.error);

  }, [authState.token, fetchData]);

  useEffect(() => {
      if (activeTab === "myquest") {
          fetchUserQuestions();
      }
  }, [activeTab, fetchUserQuestions]);

  const handleAddUserQuestion = async (payload) => {
    try {
        const config = {
            url: "/userquest/add",
            method: "post",
            headers: { Authorization: authState.token },
            data: payload
        };

        const res = await fetchData(config);

        if (res?.status) {
            fetchUserQuestions(); // refresh list
        }

    } catch (err) {
        console.error(err);
    }
};

const handleUpdateUserQuestion = async (payload) => {
    try {
        const config = {
            url: "/userquestupdate",
            method: "post",
            headers: { Authorization: authState.token },
            data: payload
        };

        const res = await fetchData(config);

        if (res?.status) {
            fetchUserQuestions();
        }

    } catch (err) {
        console.error(err);
    }
};

const handleDeleteUserQuestion = async (questId) => {
    try {
        const config = {
            url: `/userquestdelete/${questId}`,
            method: "post",
            headers: { Authorization: authState.token }
        };

        const res = await fetchData(config);

        if (res?.status) {
            fetchUserQuestions();
        }

    } catch (err) {
        console.error(err);
    }
};
 
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  // Basic validation
  if (!formData.questionTitle){
    alert("Question Title is required.");
    return;
  }

  if (!formData.examTitle){
    alert("Exam Title is required.");
    return;
  }

  if (!formData.seriesTitle){
    alert("Series Title is required.");
    return;
  }

  if (!formData.setTitle){
    alert("Set Title is required.");
    return;
  }

  // Prepare payload
  const payload = {
    // 🔹 Core Question
    question: formData.digibName, // using Name as Question
    questionType: "MCQ",

    // 🔹 MCQ Structure (TEMP DEFAULT - upgrade later)
    mcqOptions: [{
      A: "Option A",
      B: "Option B",
      C: "Option C",
      D: "Option D"
    }],
    mcqCorrectAnswer: "A",

    // 🔹 Mapping your existing fields
    subject: formData.digibState,
    chapter: formData.digibPlace,
    tags: formData.selectedBoutiques.join(", "),
    idealShortAnswer: formData.digibDetails,

    // 🔹 Difficulty / Metadata
    difficulty: "Medium",
    concept: [],

    // 🔹 Scoring
    correctAnswerPoints: 4,
    wrongAnswerPoints: -1,

    // 🔹 System Flags
    isT5w: 0,
    hasExplanation: 0,
    isActive: 1,
    isDeleted: 0,
    isUserQuestion: true,
    isApproved: false,

    // 🔹 Image Handling
    isImageQuestion: 0,
    questionImage: "",
    hasOptionImages: 0,
    imageType: "",

    // 🔹 Ownership
    createBy: userId,
    userCode: userThink5WhysCode,
    dateCreated: new Date(),

    // 🔹 Optional (keep null-safe)
    setId: null,
    setCode: "",
    seriesId: null,
    questionDisplaySn: 0,
    questionId: `UQ-${Date.now()}`,

    examId: null,
    examTitle: "",
    section: "",

  };

  const config = {
    url: "/userquest/create",
    method: "post",
    headers: { Authorization: authState.token },
    data: payload,
  };

  fetchData(config)
    .then((res) => {
      if (res?.status) {
        alert("Question submitted successfully!");

        // 🔥 Reset form aligned with QUESTION FLOW
        setFormData({
          digibThink5WhysCode: GenerateDigiBCode(),

          // 🔹 Question Mapping Fields
          digibName: "",          // question
          digibPlace: "",         // chapter
          digibState: "",         // subject
          digibDetails: "",       // explanation / short answer
          selectedBoutiques: [],  // tags

          // 🔹 User Info (retain)
          digibOwnerThink5whysCode: userThink5WhysCode,
          digibOwnerName: userName,
          digibEmail: userEmail,

          // 🔹 Optional (not used in payload but keeping UI intact)
          digibMobile: "",
          digibAddress: "",
          digibPIN: "",
          digibMicroPage: "",
        });

        // 🔥 Optional: refresh list if on myquest
        if (activeTab === "myquest") {
          fetchUserQuestions();
        }

      } else {
        alert(res?.msg || "Failed to submit question. Try again.");
      }
    })
    .catch((err) => {
      console.error("Submit Question Error:", err);
      alert("Error submitting question. Please try again.");
    });
};

const loadMyBoutiques = useCallback(() => {
  const config = {
    url: "/digiboutique/mydigib",
    method: "post",
    headers: { Authorization: authState.token },
    data: { createdBy: userId },
  };

  fetchData(config)
    .then((res) => {
      if (res?.status) {
        setMyBoutiques(res.digiBList || []);
      }
    })
    .catch(() => console.log("Error loading boutiques"));
}, [userId, authState.token]);

useEffect(() => {
  if (userId) loadMyBoutiques();
}, [userId, loadMyBoutiques]);

const formattedUserQuest = userQuestionList.map((q, index) => ({
  sn: index + 1,
  name: q.question,
  type: q.subject || "-",
  status: q.isApproved ? "Approved" : "Pending",
  dateCreated: q.dateCreated
    ? new Date(q.dateCreated).toLocaleDateString()
    : "-",
  raw: q
}));

  const handleBoutiqueClick = (boutique) => {
    setSelectedBoutique(boutique);
  };

  const closeMembersList = () => {
    setSelectedBoutique(null);
    setMemberSearch("");
  };

  return (
    <div className="bg-black h-screen flex flex-col">
      <header className="flex flex-col px-2 py-2 bg-cyan-800 shadow-md sticky top-0 z-50">
        <div className="text-xl font-extrabold text-yellow-200 tracking-wide">
          Suggest Question for ExamUnion
        </div>
        <p className="text-xs lg:text-sm text-white text-left">
          Bring your creativity to the world!
        </p>
      </header>

      <div className="min-h-[85vh]">
        {/* Tabs */}
        <nav className="flex flex-wrap justify-center gap-2 bg-black py-1 border-b border-cyan-400">
          {["quest", "myquest"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`flex-1 min-w-[100px] text-center px-4 py-2 rounded-lg text-sm sm:text-base font-semibold truncate transition 
                ${
                  activeTab === tab
                    ? "bg-cyan-600 text-yellow-200 shadow-lg"
                    : "bg-cyan-800 hover:bg-cyan-700 text-white"
                }`}
            >
              {tab === "quest" && "Suggest Question"}
              {tab === "myquest" && "Suggested Questions"}
            </button>
          ))}
        </nav>

        {/* Suggest Question Section */}
        {activeTab === "quest" && (
          <section className="py-2 px-4 bg-black">
            <h2 className="text-xl lg:text-2xl font-bold text-center mb-2 text-yellow-200">Suggest Question</h2>
            <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-4">
              <div className="flex flex-col gap-4">
                <input
                  type="text"
                  name="digibThink5WhysCode"
                  value={formData.digibThink5WhysCode}
                  disabled={true}
                  onChange={handleInputChange}
                  className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />
                <input
                  type="text"
                  name="digibName"
                  placeholder="Boutique Name"
                  value={formData.digibName}
                  onChange={handleInputChange}
                  style={{width: "90%"}}
                  className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white w-ful"
                  required
                />
                <input
                  type="text"
                  name="digibOwnerThink5whysCode"
                  value={formData.digibOwnerThink5whysCode}
                  disabled={true}
                  onChange={handleInputChange}
                  className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />
                <input
                  type="text"
                  name="digibOwnerName"
                  value={formData.digibOwnerName}
                  disabled={true}
                  onChange={handleInputChange}
                  style={{width: "90%"}}
                  className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />
                <input
                  type="email"
                  name="digibEmail"
                  value={formData.digibEmail}
                  disabled={true}
                  onChange={handleInputChange}
                  className="flex-1 px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />
                <input
                  type="tel"
                  name="digibMobile"
                  placeholder="Mobile Number"
                  value={formData.digibMobile}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />
                <textarea
                  type="text"
                  name="digibAddress"
                  placeholder="Address"
                  value={formData.digibAddress}
                  onChange={handleInputChange}
                  style={{width: "100%", height: "150px"}}
                  className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                /> 
                <input
                  type="text"
                  name="digibPlace"
                  placeholder="Place"
                  value={formData.digibPlace}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />            
                <input
                  type="text"
                  name="digibState"
                  placeholder="State"
                  value={formData.digibState}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />      
                <input
                  type="text"
                  name="digibPIN"
                  placeholder="PIN Code"
                  value={formData.digibPIN}
                  onChange={handleInputChange}
                  style={{width: "100px"}}
                  className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />         
                <textarea
                  type="text"
                  name="digibDetails"
                  placeholder="Boutique Details"
                  value={formData.digibDetails}
                  onChange={handleInputChange}
                  style={{width: "100%", height: "200px"}}
                  className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />  
                <textarea
                  type="text"
                  name="digibMicroPage"
                  placeholder="Boutique Webpage"
                  value={formData.digibMicroPage}
                  onChange={handleInputChange}
                  style={{width: "100%", height: "400px"}}
                  className="w-full px-4 py-2 rounded-lg text-gray-800 bg-white"
                  required
                />   
              </div>                
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
                {boutiques.map((b, idx) => (
                  <label key={idx} className="flex items-center gap-2 bg-white/10 p-2 rounded-lg cursor-pointer hover:bg-white/20 transition">
                    <input
                      type="checkbox"
                      checked={formData.selectedBoutiques.includes(b.name)}
                      onChange={() => handleBoutiqueSelection(b.name)}
                    />
                    <span className="text-white text-sm">{b.name}</span>
                  </label>
                ))}
              </div>
              <button type="submit" className="w-full py-2 bg-blue-600 hover:bg-blue-700 rounded-lg font-semibold text-white">
                Submit Question
              </button>
            </form>
          </section>
        )}

        {/* My Suggested Questions Section */}
        {activeTab === "myquest" && (
          <section className="min-h-screen py-2 px-4 bg-black">
            <h2 className="text-xl lg:text-2xl font-bold text-center mb-2 text-yellow-200">
              My Suggested Questions
            </h2>

            <div className="overflow-x-auto">
              <table className="w-full min-w-[600px] bg-gray-800 border border-cyan-500 rounded-lg">
                <thead className="bg-cyan-900">
                  <tr>
                    {["SN", "Boutique Name", "Type", "Status", "Date Created"].map(
                      (heading) => (
                        <th
                          key={heading}
                          className="p-3 text-left text-cyan-200 text-sm"
                        >
                          {heading}
                        </th>
                      )
                    )}
                  </tr>
                </thead>

                <tbody>
                  {formattedUserQuest.length > 0 ? (
                    formattedUserQuest.map((row) => (
                      <tr key={row.sn} className="hover:bg-gray-700 transition">
                        <td className="p-3 border-t border-cyan-500 text-white">{row.sn}</td>

                        <td className="p-3 border-t border-cyan-500 text-white">
                          {row.name}
                        </td>

                        <td className="p-3 border-t border-cyan-500 text-white">
                          {row.type}
                        </td>

                        <td className="p-3 border-t border-cyan-500">
                          <span
                            className={`px-2 py-1 rounded text-xs ${
                              row.status === "Approved"
                                ? "bg-green-600"
                                : "bg-yellow-600"
                            }`}
                          >
                            {row.status}
                          </span>
                        </td>

                        <td className="p-3 border-t border-cyan-500 text-white">
                          {row.dateCreated}
                        </td>

                        {/* 🔥 NEW COLUMN (NO UI BREAK) */}
                        <td className="p-3 border-t border-cyan-500 text-white">
                          {!row.raw.isApproved && (
                            <div className="flex gap-2">
                              <button
                                onClick={() =>
                                  handleUpdateUserQuestion({
                                    _id: row.raw._id,
                                    question: row.raw.question + " (Edited)"
                                  })
                                }
                                className="bg-blue-600 px-2 py-1 rounded text-xs"
                              >
                                Edit
                              </button>

                              <button
                                onClick={() => handleDeleteUserQuestion(row.raw._id)}
                                className="bg-red-600 px-2 py-1 rounded text-xs"
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="p-4 text-center text-gray-300 border-t border-cyan-500"
                      >
                        No suggestion found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
        )}
      </div>

      {/* Members List Modal */}
      {/* {selectedBoutique && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-gray-800 p-6 rounded-lg max-w-md w-full mx-4 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-yellow-200">
                {selectedBoutique.name} Members ({filteredMembers.length})
              </h3>
              <button onClick={closeMembersList} className="text-white hover:text-cyan-200 text-2xl">&times;</button>
            </div>
            <input
              type="text"
              placeholder="Search members..."
              value={memberSearch}
              onChange={(e) => setMemberSearch(e.target.value)}
              className="w-full bg-gray-900 border border-cyan-500 rounded p-2 text-white mb-4"
            />
            <ul className="space-y-2 text-sm">
              {filteredMembers.map((member, idx) => (
                <li key={idx} className="p-2 bg-gray-700 rounded flex justify-between">
                  <span className="text-white">{member.name}</span>
                  <span className="text-gray-400">{member.role} | {member.joined}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )} */}

      {/* Footer */}
      <footer className="bg-cyan-800 text-white py-2 px-2 sm:px-2 md:px-4">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-xs lg:text-sm text-yellow-200">&copy; 2025 Think5Whys Global DeepTech Solutions</p>
          <div className="flex space-x-6 mt-1 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-cyan-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-cyan-400 transition">Privacy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-cyan-400 transition">Terms</Link>
            <Link to="/contact-us" className="text-white hover:text-cyan-400 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ExamUnionSuggestQuest;
